module.exports = __webpack_public_path__ + "static/media/listing-page-phuket.101ea276.webp";